import { DropdownOptionProps } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';
import { MonthAvailability } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';

export const monthlyAvailabilityOptions: DropdownOptionProps[] = [
  {
    value: MonthAvailability.EVERY_DAY,
    text: 'Every day of the month',
  },
  {
    value: MonthAvailability.ON_SPECIFIC_DAY,
    text: 'On a specific day',
  },
  {
    value: MonthAvailability.WITHIN_DATE_RANGE,
    text: 'Within a date range',
  },
];
